import React, { Component } from 'react'

export default class HistoryLine extends Component {
    render() {
        return (
            <div className='history-line smr-table-line'> 
                <div>{this.props.item.regNumOrUserName + (this.props.item.batchVersion < 2 ? '' : (' в.' + this.props.item.batchVersion)) }</div>
                <div>{this.props.item.regDateOrLastModifyDate }</div>
                <div><button onClick={ _=> this.props.OnExportClicked(this.props.item) }
                             className="download-document-button">Скачать</button></div>
            </div>
        )
    }
}